/** Controlled labelled input / select / textarea. Module-level so it never remounts. */
export default function Field({ label, error, as = 'input', children, ...props }) {
  const Tag = as;
  return (
    <div className="field">
      {label && <label>{label}</label>}
      <Tag {...props}>{children}</Tag>
      {error && <span className="err">{error}</span>}
    </div>
  );
}
